import { render, staticRenderFns } from "./VehicleKeyBoard.vue?vue&type=template&id=f0201566&scoped=true&"
import script from "./VehicleKeyBoard.vue?vue&type=script&lang=js&"
export * from "./VehicleKeyBoard.vue?vue&type=script&lang=js&"
import style0 from "./VehicleKeyBoard.vue?vue&type=style&index=0&id=f0201566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0201566",
  null
  
)

export default component.exports